import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, CardContent, Typography } from "@material-ui/core";
import cardStyles from "../styles/cardStyles";
import ApiService from "../../service/ApiService";
import DatabaseEntities from "../../model/enum/DatabaseEntities";
import Calendar from "react-calendar";
import TodayIcon from "@mui/icons-material/Today";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AppointmentModel from "../../model/appointment";
import DateConverter from "../../utils/DateConverter";
import US_States from "../../model/enum/US_States";
import AppointmentDetailModal from "../appointment/AppointmentDetailModal";
import Pathnames from "../../model/enum/Pathnames";
import PageResultResponse from "../../model/pageResultResponse";
import styled from "styled-components";
import useStyles from "./styles";
import Misc from "../../utils/Misc";
import DB_Status from "../../model/enum/DB_Status";
import ClientInfoModal from "../client/ClientInfoModal";

// Customize the button styles here
export const CalendarWrapper = styled.div`
  .react-calendar__navigation__label,
  .react-calendar__navigation__arrow {
    background-color: white; /* Custom color */
    color: black; /* Button text color */
    border: none; /* Remove default border */
    padding: 5px 10px;
    border-radius: 20px;
    cursor: pointer;
  }

  .react-calendar__navigation__arrow:hover,
  .react-calendar__navigation__label:hover {
    background-color: #0056b3; /* Darker shade on hover */
  }

  .react-calendar__tile--active {
    color: white; /* Text color for active date */
    background: #1e2e55;
    border-radius: 20px; /* Optional: make the button rounded */
  }

  .react-calendar__tile--active:hover {
    background-color: #1e2e5580; /* Darker color on hover */
  }
`;

const UpcomingMeetings = () => {
  const classes = useStyles();
  const styles = cardStyles();
  const [appointments, setAppointments] = useState<AppointmentModel[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const abbv = new US_States();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await ApiService.get<PageResultResponse>(
        `${DatabaseEntities.APPOINTMENTS}?upcomings=true`
      ).then((data: PageResultResponse) => {
        setAppointments(data.items);
      });
      setLoading(false);
    };

    if (loading && Misc.isArrayEmpty(appointments)) fetchData();
  }, [appointments]);

  const Loading = () => {
    return <>Loading...</>;
  };

  return (
    <>
      <Card raised className={styles.card}>
        {loading ? (
          <Loading />
        ) : (
          <>
            <div className={styles.headerContainer}>
              <Typography className={styles.title}>
                Upcoming Meetings
              </Typography>
            </div>
            <CardContent className={classes.container}>
              <div className={classes.subContainer}>
                {appointments.length > 0 ? (
                  appointments.map((appointment: AppointmentModel, index) => {
                    return (
                      <>
                        {/* <div
                          style={DB_Status.mapUpcomingStatusColor(
                            appointment.Status?.name
                          )}
                        >|</div> */}
                        <div className={classes.name} key={index}>
                          <ClientInfoModal clientData={appointment.Client} />
                        </div>
                        <div className={classes.item}>
                          <div className={classes.content}>
                            <TodayIcon />
                            {DateConverter.toFullDate(appointment.scheduledAt)}
                            {" at "}
                            {DateConverter.convertTo12HourFormat(
                              appointment.initialTime
                            )}
                          </div>
                          <div style={{ width: "30px" }}>|</div>
                          <LocationOnIcon />
                          <div className={classes.content}>
                            {appointment.Client?.street && (
                              <>{appointment.Client.street}</>
                            )}
                            {appointment.Client?.city && (
                              <>, {appointment.Client.city}</>
                            )}
                            {appointment.Client?.zip && (
                              <>
                                ,{" "}
                                {abbv.getStateAbbreviation(
                                  appointment.Client.zip
                                )}
                              </>
                            )}
                          </div>
                          <AppointmentDetailModal appointment={appointment} />
                        </div>
                        {index < appointments.length - 1 && (
                          <hr style={{ width: "100%" }} />
                        )}
                      </>
                    );
                  })
                ) : (
                  <>No appointments for the upcoming days.</>
                )}
              </div>
              <div
                className={`calendar-container ${classes.calendarContainer}`}
              >
                <CalendarWrapper>
                  <Calendar
                    className={classes.calendar}
                    calendarType={"US"}
                    value={new Date()}
                  />
                </CalendarWrapper>
                <Button
                  className={classes.button}
                  onClick={() => navigate(Pathnames.APPOINTMENTS_LIST)}
                >
                  View Appointments
                </Button>
              </div>
            </CardContent>
          </>
        )}
      </Card>
    </>
  );
};

export default UpcomingMeetings;
